import { useEffect, useState } from "react";

import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Image,
  ProgressBar,
  Spinner,
  CloseButton,
  Card,
  Badge,
} from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { formatDate, handleCopyToCB } from "../../helpers/utils";
import API from "../../api/api";

function AdminAffiliatesModal({
  show,
  handleClose,
  payload,
  setPayload,
  getAllData,
  hostname,
  user,
}) {
  console.log(payload);

  const [loader, setLoader] = useState(false);

  //remember to use API after creating admin in DB in prod mode
  const AddUserDB = async (values, { setSubmitting, resetForm }) => {
    console.log(values);
    // setSubmitting(false);

    // return;

    axios
      .post(`${hostname}/api/users/create`, {
        ...values,
      })
      .then((res) => {
        console.log(res.data);
        toast.success("Affilate Added.", { theme: "colored" });
        setSubmitting(false);
        resetForm();
        getAllData();
        handleClose();
        setPayload({});
      })
      .catch((err) => {
        console.log(err);
        setSubmitting(false);
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  const updateUserDB = async (values, { setSubmitting, resetForm }) => {
    console.log(values);
    // setSubmitting(false);

    let obj = { ...values };
    if (!obj.password) delete obj.password;

    // return;

    API.patch(`/api/users/update/${payload._id}`, {
      ...obj,
    })
      .then((res) => {
        console.log(res.data);
        toast.success("Affilate updated.", { theme: "colored" });
        setSubmitting(false);
        resetForm();
        getAllData();
        handleClose();
        setPayload({});
      })
      .catch((err) => {
        console.log(err);
        setSubmitting(false);
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  const deleteEntry = () => {
    API.delete(`/api/users/delete/${payload._id}`)
      .then((res) => {
        console.log(res.data);
        getAllData();
        handleClose();
        toast.warning("Affiliate deleted.", { theme: "colored" });
        setPayload({});
      })
      .catch((err) => {
        console.log(err);
        getAllData();
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  const getPasswordAndCopyToClipboard = () => {
    setLoader(true);
    // setTimeout(() => {
    //   setLoader(false);
    // }, 500);
    // return;
    API.post("/api/auth/request-reset", {
      email: "shadow7852845@gmail.com",
    })
      .then((res) => {
        console.log(res.data);
        toast.success(res.data.message);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>{payload.loadType}</Modal.Title>
        <CloseButton onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        {payload.loadType === "Add Affiliate" && (
          <Formik
            initialValues={{
              first_name: "",
              last_name: "",
              email: "",
              phone: "",
              referral_code: "",
              reference_by_code: "",
              user_name: "",
              password: "",
              address: "",
              city: "",
              postal: "",
              country: "Pakistan",
              status: "active",
              role: "customer",
              payment_status: "unpaid",
            }}
            validationSchema={Yup.object().shape({
              first_name: Yup.string().required("First name is required"),
              last_name: Yup.string().required("Last name is required"),
              email: Yup.string()
                .email("Invalid email")
                .matches(
                  /^[\w.+-]+@gmail\.com$/,
                  "Only @gmail.com emails are allowed"
                )
                .required("Email is required"),
              phone: Yup.string().required("Phone is required"),
              // referral_code: Yup.string().required("Referral Code is required"),
              // user_name: Yup.string().required("Username is required"),
              password: Yup.string().min(
                6,
                "Password must be at least 6 chars"
              ),
              // .required("Password is required"),
              address: Yup.string(),
              city: Yup.string(),
              postal: Yup.string(),
              country: Yup.string(),
              status: Yup.string().oneOf(["active", "inactive"]),
              role: Yup.string().oneOf(["admin", "distributor", "customer"]),
              payment_status: Yup.string().oneOf([
                "unpaid",
                "processing",
                "paid",
              ]),
            })}
            onSubmit={AddUserDB}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Modal.Body>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="first_name"
                        value={values.first_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.first_name && !!errors.first_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.first_name}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="last_name"
                        value={values.last_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.last_name && !!errors.last_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.last_name}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.email && !!errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.phone && !!errors.phone}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.phone}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Referral Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="referral_code"
                        value={values.referral_code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.referral_code && !!errors.referral_code
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.referral_code}
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Referrenced By Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="reference_by_code"
                        value={values.reference_by_code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.reference_by_code &&
                          !!errors.reference_by_code
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.reference_by_code}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Username</Form.Label>
                      <Form.Control
                        type="text"
                        name="user_name"
                        value={values.user_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.user_name && !!errors.user_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.user_name}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="password"
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.password && !!errors.password}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-12 mb-3">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={values.address}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        value={values.city}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Postal Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="postal"
                        value={values.postal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Country</Form.Label>
                      <Form.Control
                        type="text"
                        name="country"
                        value={values.country}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </Form.Select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Role</Form.Label>
                      <Form.Select
                        name="role"
                        value={values.role}
                        onChange={handleChange}
                      >
                        <option value="customer">Customer</option>
                        <option value="distributor">Distributor</option>
                        <option value="admin">Admin</option>
                      </Form.Select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Payment Status</Form.Label>
                      <Form.Select
                        name="payment_status"
                        value={values.payment_status}
                        onChange={handleChange}
                      >
                        <option value="unpaid">Unpaid</option>
                        <option value="processing">Processing</option>
                        <option value="paid">Paid</option>
                      </Form.Select>
                    </div>
                  </div>
                  <div className="text-end">
                    <br />
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={isSubmitting}
                    >
                      Add
                    </Button>
                  </div>
                </Modal.Body>
              </Form>
            )}
          </Formik>
        )}

        {payload.loadType === "View Affiliate" && (
          <Card className="shadow border-0">
            <Card.Body>
              {/* Header Info */}
              <Row className="mb-3">
                <Col
                  md={12}
                  className="d-flex justify-content-between align-items-center"
                >
                  <Badge bg={payload.roleObj.type}>
                    {payload.roleObj.title}
                  </Badge>
                  <h5 className="text-center">
                    {payload.first_name} {payload.last_name} <br />
                    <span style={{ fontSize: "14px" }}>
                      {formatDate(payload.createdAt)}
                    </span>
                  </h5>
                  <Badge bg={payload.statusObj.type}>
                    {payload.statusObj.title}
                  </Badge>
                </Col>
              </Row>

              {/* Details (all hardcoded) */}
              <Row>
                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>First Name:</strong>
                      <br />
                      <span>{payload.first_name || "—"}</span>
                    </div>
                    {payload.first_name && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.first_name)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Last Name:</strong>
                      <br />
                      <span>{payload.last_name || "—"}</span>
                    </div>
                    {payload.last_name && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.last_name)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Email:</strong>
                      <br />
                      <span>{payload.email || "—"}</span>
                    </div>
                    {payload.email && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.email)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Phone:</strong>
                      <br />
                      <span>{payload.phone || "—"}</span>
                    </div>
                    {payload.phone && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.phone)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Referral Code:</strong>
                      <br />
                      <span>{payload.referral_code || "—"}</span>
                    </div>
                    {payload.referral_code && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.referral_code)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Reference by Code:</strong>
                      <br />
                      <span>{payload.reference_by_code || "—"}</span>
                    </div>
                    {payload.reference_by_code && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() =>
                          handleCopyToCB(payload.reference_by_code)
                        }
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Username:</strong>
                      <br />
                      <span>{payload.user_name || "—"}</span>
                    </div>
                    {payload.user_name && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.user_name)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                {user?.role === "admin" && (
                  <Col md={6} className="mb-3">
                    <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                      <div>
                        <strong>Password:</strong>
                        <br />
                        {payload.user_name ? <span>**********</span> : "—"}
                      </div>
                      {payload.user_name && (
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          disabled={loader}
                          onClick={() => getPasswordAndCopyToClipboard()}
                        >
                          {loader ? <Spinner size="sm" /> : "📋"}
                        </Button>
                      )}
                    </div>
                  </Col>
                )}

                {user?.role === "distributor" && (
                  <Col md={6} className="mb-3">
                    <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                      <div>
                        <strong>Password:</strong>
                        <br />
                        {payload.user_name ? "Request Admin for change" : "—"}
                      </div>
                      {/* <Button
                        size="sm"
                        variant="outline-secondary"
                        disabled={loader}
                        onClick={() => getPasswordAndCopyToClipboard()}
                      >
                        {loader ? <Spinner size="sm" /> : "📋"}
                      </Button> */}
                    </div>
                  </Col>
                )}

                <Col md={12} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Address:</strong>
                      <br />
                      <span>{payload.address || "—"}</span>
                    </div>
                    {payload.address && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.address)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Payment Status:</strong>
                      <br />
                      {payload.payment_status_obj ? (
                        <Badge bg={payload.payment_status_obj.type}>
                          {payload.payment_status_obj.title}
                        </Badge>
                      ) : (
                        "—"
                      )}
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>City:</strong>
                      <br />
                      <span>{payload.city || "—"}</span>
                    </div>
                    {payload.city && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.city)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Postal:</strong>
                      <br />
                      <span>{payload.postal || "—"}</span>
                    </div>
                    {payload.postal && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.postal)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Country:</strong>
                      <br />
                      <span>{payload.country || "—"}</span>
                    </div>
                    {payload.country && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => handleCopyToCB(payload.country)}
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Created At:</strong>
                      <br />
                      <span>{formatDate(payload.createdAt, true) || "—"}</span>
                    </div>
                    {formatDate(payload.createdAt, true) && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() =>
                          handleCopyToCB(formatDate(payload.createdAt, true))
                        }
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="p-3 border rounded bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Updated At:</strong>
                      <br />
                      <span>{formatDate(payload.updatedAt, true) || "—"}</span>
                    </div>
                    {formatDate(payload.updatedAt, true) && (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() =>
                          handleCopyToCB(formatDate(payload.updatedAt, true))
                        }
                      >
                        📋
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}

        {payload.loadType === "Update Affiliate" && (
          <Formik
            initialValues={{
              first_name: payload.first_name || "",
              last_name: payload.last_name || "",
              email: payload.email || "",
              phone: payload.phone || "",
              referral_code: payload.referral_code || "",
              reference_by_code: payload.reference_by_code || "",
              user_name: payload.user_name || "",
              password: "", // update by new , not with old
              address: payload.address || "",
              city: payload.city || "",
              postal: payload.postal || "",
              country: "Pakistan",
              status: payload.status || "active",
              role: payload.role || "customer",
              payment_status: payload.payment_status || "unpaid",
            }}
            validationSchema={Yup.object().shape({
              // first_name: Yup.string().required("First name is required"),
              // last_name: Yup.string().required("Last name is required"),
              email: Yup.string().email("Invalid email"),
              // .required("Email is required"),
              // phone: Yup.string().required("Phone is required"),
              // referral_code: Yup.string().required("Referral Code is required"),
              // user_name: Yup.string().required("Username is required"),
              password: Yup.string().min(
                6,
                "Password must be at least 6 chars"
              ),
              // .required("Password is required"),
              address: Yup.string(),
              city: Yup.string(),
              postal: Yup.string(),
              country: Yup.string(),
              status: Yup.string().oneOf(["active", "inactive"]),
              role: Yup.string().oneOf(["admin", "distributor", "customer"]),
              payment_status: Yup.string().oneOf([
                "unpaid",
                "processing",
                "paid",
              ]),
            })}
            onSubmit={updateUserDB}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Modal.Body>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="first_name"
                        value={values.first_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.first_name && !!errors.first_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.first_name}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="last_name"
                        value={values.last_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.last_name && !!errors.last_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.last_name}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.email && !!errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.phone && !!errors.phone}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.phone}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Referral Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="referral_code"
                        value={values.referral_code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.referral_code && !!errors.referral_code
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.referral_code}
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Referrenced By Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="reference_by_code"
                        value={values.reference_by_code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.reference_by_code &&
                          !!errors.reference_by_code
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.reference_by_code}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Username</Form.Label>
                      <Form.Control
                        type="text"
                        name="user_name"
                        value={values.user_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.user_name && !!errors.user_name}
                        autoComplete="off"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.user_name}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="password"
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.password && !!errors.password}
                        autoComplete="new-password"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-12 mb-3">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={values.address}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        value={values.city}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Postal Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="postal"
                        value={values.postal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Country</Form.Label>
                      <Form.Control
                        type="text"
                        name="country"
                        value={values.country}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </Form.Select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Role</Form.Label>
                      <Form.Select
                        name="role"
                        value={values.role}
                        onChange={handleChange}
                      >
                        <option value="customer">Customer</option>
                        <option value="distributor">Distributor</option>
                        <option value="admin">Admin</option>
                      </Form.Select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Payment Status</Form.Label>
                      <Form.Select
                        name="payment_status"
                        value={values.payment_status}
                        onChange={handleChange}
                      >
                        <option value="unpaid">Unpaid</option>
                        <option value="processing">Processing</option>
                        <option value="paid">Paid</option>
                      </Form.Select>
                    </div>
                  </div>
                  <div className="text-end">
                    <br />
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={isSubmitting}
                    >
                      Update
                    </Button>
                  </div>
                </Modal.Body>
              </Form>
            )}
          </Formik>
        )}

        {payload.loadType === "Delete Affiliate" && (
          <div>
            <>
              <p className="text-danger">
                Are you sure you want to delete affiliate{" "}
                <span className="text-primary">"{payload.first_name} </span>
                <span className="text-primary">{payload.last_name}" </span>with
                code
                <span className="text-primary"> "{payload.referral_code}"</span>
                ?
              </p>
              <br />
              <div className="text-end">
                <Button
                  variant="danger"
                  className="me-3 "
                  size="md"
                  onClick={deleteEntry}
                  style={{ width: 80 }}
                >
                  Yes
                </Button>
                <Button
                  variant="secondary"
                  size="md"
                  onClick={handleClose}
                  style={{ width: 80 }}
                >
                  No
                </Button>
              </div>
            </>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default AdminAffiliatesModal;
